import React, { FC } from 'react';
import { withWebHeader } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader';
import { Loader } from '@24i/nxg-sdk-gluons';

const StripePaymentMethodView: FC = () => <Loader />;

export default withWebHeader(StripePaymentMethodView);
